import { render, staticRenderFns } from "./RouterOpenChannel.vue?vue&type=template&id=cc611686&"
import script from "./RouterOpenChannel.vue?vue&type=script&lang=js&"
export * from "./RouterOpenChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports